<app-stages [stages]="stages" currentStage="Wnioskodawca">
</app-stages>
<br>
@if (!pending() && !loading()) {
  @if (investors().length) {
    <app-accordion-group>
      @for (investor of investors(); track $index) {
        <app-accordion-item
          [name]='$index + 1 + ". " + (investor?.applicant | entityLabel)'>
          <app-opinion-on-issuing-a-decision-investor-item-preview
            *ngIf='investor?.applicant as item'
            [investor]='item'>
          </app-opinion-on-issuing-a-decision-investor-item-preview>
          <span slot='action'>
            <button
              (click)='onEditInvestor($event, $index)'
              class='btn btn-secondary icon-btn'
              title='Edytuj'
              [disabled]='showItemForm'>
              <i class='fa fa-pencil-alt'></i>
            </button>
            &nbsp;
            <button
              [disabled]='showItemForm'
              type='button'
              class='btn btn-red-secondary icon-btn'
              title='Usuń z listy'
              (click)='onRemove($index, $event)'>
              <i class='fa fa-trash-alt'></i>
            </button>
          </span>
        </app-accordion-item>
      }
    </app-accordion-group>
  } @else {
    <app-alert alertTittle="Brak dodanych wnioskodawców!" [closable]="false"></app-alert>
  }
  @if (!showItemForm) {
    <br>
    <div class='d-flex justify-content-end'>
      <button type='button' class='btn btn-primary' (click)='onAdd()'>
        {{ investors().length ? "Aby dodać kolejnego wnioskodawcę" : "Dodaj dane wnioskodawcy" }}
      </button>
    </div>
  }
  @if (showItemForm) {
    <div class='gov-card'>
      <div class='gov-card__header'>
        Dodanie wnioskodawcy
      </div>
      <div class='gov-card__body'>
        <app-tab-view #tabViewComponent [centered]='true'>
          @for (entityType of entityTypes(); track $index) {
            @if (entityType.code === "OSOBA_FIZYCZNA") {
              <app-tab-panel #naturalPersonTab [name]='entityType.name' [selected]='$index === 0'>
                <app-opinion-on-issuing-a-decision-investor-natural-person-form
                  *ngIf='naturalPersonTab.selected'
                  [edit]='currentIndex() !== undefined'
                  [form]='investorForm'
                  (onCancel)='this.showItemForm = false'
                  (onSubmit)='onUpdateInvestors($event)'>
                </app-opinion-on-issuing-a-decision-investor-natural-person-form>
              </app-tab-panel>
            }
            @if (entityType.code === 'OSOBA_PRAWNA') {
              <app-tab-panel #companyTab [name]='entityType.name' [selected]='$index === 0'>
                <app-opinion-on-issuing-a-decision-investor-company-form
                  *ngIf='companyTab.selected'
                  [edit]='currentIndex() !== undefined'
                  [form]='investorForm'
                  (onCancel)='this.showItemForm = false'
                  (onSubmit)='onUpdateInvestors($event)'>
                </app-opinion-on-issuing-a-decision-investor-company-form>
              </app-tab-panel>
            }
          }
        </app-tab-view>
      </div>
    </div>
    <br>
  }
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary'
      (click)='onCancel()'>
        <span>
          Wstecz
        </span>
    </button>
    <button
      [disabled]="showItemForm"
      type='button'
      class='btn btn-primary'
      (click)='submitAndGoNext()'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
